<script>

import { sync } from 'vuex-pathify'
import datePicker from '@/mixins/date-picker'
import moment from 'moment'

export default {
    name: 'DebuggerFilterCard',
    mixins: [datePicker],
    data () {
        return {
            rules: {
                senderId: [
                    {
                        required: true,
                        message: this.$i18n.t('formRules.fieldRequired'),
                        trigger: 'blur'
                    }
                ]
            }
        }
    },
    computed: {
        moment () {
            return moment
        },
        defaultTime () {
            return [moment().format('HH:mm:ss'), moment().format('HH:mm:ss')]
        },
        filter: sync('debug/filter')
    },
    methods: {
        submitForm () {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    const [start, end] = this.filter.range
                    this.$router.push({
                        name: 'Debugger',
                        query: {
                            sender_id: this.filter.senderId,
                            from_time: start,
                            to_time: end
                        }
                    }).catch(() => {})
                } else {
                    return false
                }
            })
        },
        resetForm () {
            this.$refs.ruleForm.resetFields()
        }
    }
}
</script>

<template>
  <el-form class="filter-card d-flex flex-column pa-8 rounded" :model="filter" :rules="rules" ref="ruleForm">
    <span class="text-center font-weight-bold">{{ $t('debugger.filterTitle') }}</span>
    <div class="d-flex flex-column">
      <el-form-item prop="senderId">
        <el-input v-model="filter.senderId" size="small" clearable
                  placeholder="Sender Id"></el-input>
      </el-form-item>
      <el-form-item prop="range">
        <el-date-picker :default-time="defaultTime" value-format="timestamp" size="small" type="datetimerange" format="dd/MM/yyyy HH:mm:ss" :picker-options="pickerOptions"
                        :start-placeholder="this.$f.tc('from')" style="width: 100%"
                        v-model="filter.range"
                        :end-placeholder="this.$f.tc('to')"></el-date-picker>
      </el-form-item>
      <div class="d-flex align-center justify-center">
        <el-button class="font-weight-bold" @click="resetForm">{{ $t('clear') | capitalize }}</el-button>
        <el-button class="font-weight-bold" icon="el-icon-search" type="primary" @click="submitForm">{{
            $t('search') | capitalize
          }}
        </el-button>
      </div>
    </div>
  </el-form>
</template>

<style scoped lang="scss">
.filter-card {
  border: 1px solid #EDEDED;
  background: var(--ffffff, #FFF);
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.05);
  flex-direction: column;
  gap: 24px;
  max-width: 500px;
  margin-top: 60px;
}
</style>
